var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-header-bottom-row uk-hidden-print"},[_c('mobile-navigation-v2-button'),(!_vm.disableCatalogue && _vm.useMagicSearch)?_c('mobile-header-search-overlay'):(!_vm.disableCatalogue)?_c('mobile-header-search'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }